import { Asset, Collection, normalizeAssetType, normalizeAssetFormat, validateAsset } from '@cld/console-apps-types';

import { PortalCollections, PortalInfo } from './PortalData';
import { PortalCollectionsDto, portalCollectionsSchema } from './PortalCollections.dto';
import { PortalInfoDto, portalInfoSchema } from './PortalInfo.dto';

export const parseCollections = (rawData: unknown): PortalCollections => {
  const dto: PortalCollectionsDto = portalCollectionsSchema.validateSync(rawData);

  const collections: Array<Collection> = dto.collections.map((collectionDto) => {
    const assets: Array<Asset> = collectionDto.resources.assets.map((assetDto) => {
      const type = normalizeAssetType(assetDto.resourceType, assetDto.resourceSubtype);
      const format = normalizeAssetFormat(assetDto.resourceType, assetDto.publicId, assetDto.format);
      return validateAsset(assetDto.uploadType, type, { ...assetDto, format, type });
    });

    return {
      id: collectionDto.id,
      name: collectionDto.name,
      assets,
      downloadUrl: collectionDto.downloadUrl,
    };
  });

  return collections;
};

export const parseInfo = (rawData: unknown): PortalInfo => {
  const dto: PortalInfoDto = portalInfoSchema.validateSync(rawData);
  return dto;
};
